<template>
  <div :hidden="categories.length <= 0">
    <div class="collapsible" :id="'section'+(index+1)">{{filter.name}}<span></span></div>
    <div class="collapse-container">
      <div class="content collapse-content">
        <ul class="custom-checkboxes">
          <li v-for="(cat, counter) in categories" :key="counter">
            <input class="styled-checkbox" :id="'styled-checkbox-'+index+counter" v-model="filter.filters" type="checkbox"  v-bind:value="{slug: cat.slug, name: cat.name, fIndex: index}" @change="onChangeFilter($event, filter.slug, cat.slug)">
            <label :for="'styled-checkbox-'+index+counter"><span v-html="cat.name"></span> (<span>{{cat.count}}</span>)</label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

  import axios from 'axios'

  export default {
    name: "LeftFilter",
    props: ['filter', 'index', "unsetFilter"],
    data() {
      return {
        categories: [],
      }
    },

    watch : {
      unsetFilter: function (newVal, oldVal) {
        if(newVal === true) this.getCategories(-1);
        if(this.index == this.$store.state.filters.length-1) {
          this.handleDataFc();
        }
      }
    },

    methods : {

      handleDataFc: function () {
        this.$emit('interface', this.unsetFilter) // handle data and give it back to parent by interface
      },

      getCategories : function (type = 1) {

        axios.get('/wp-json/wp/v2/products/category/', {
          params: {
            taxonomy: this.filter.wp_name,
            s: this.$route.query.s,
          }
        }).then((response) => {
          var data = response.data;

          this.categories = data.filter(function (value) {
            return value.count > 0
          });

          if(type !== -1) {
            if (this.$route.query[this.filter.slug]) {
              var query = this.$route.query[this.filter.slug].split(',');
              this.categories.map((cat) => {

                if (query.indexOf(cat.slug) !== -1) {
                  this.filter.filters.push({
                    slug: cat.slug,
                    name: cat.name,
                    fIndex: this.index
                  })
                }

              });
            }
          }

          this.$emit('loadData');
          // if(this.index == this.$store.state.filters.length-1) {
          //   this.onChangeFilter();
          // }


        }, (error) => {
          console.log(error)
        })
      },


      onChangeFilter : function(e, fSlug= null, cat = null) {
        this.$store.commit('SET_LOADER', true);

        var query = this.$store.state.filters.reduce(
          (obj, cat) => {
            return Object.assign(
                obj,
                {
                  [cat.slug] : this.$store.getters.get_filters(cat.slug).join(','),
                }
              )
          }
          , {}
          );

        if(this.$route.query.s) {
          Object.assign(query, {s: this.$route.query.s});
          this.$store.commit('SET_SEARCH', this.$route.query.s);
        }

        if(this.$route.query.promo !== undefined) {
          var promo = JSON.parse(this.$route.query.promo);
          if (promo === true) {
            Object.assign(query, {promo: promo});
          }
        }

        this.$router.push({query: query});

        this.$store.commit('SET_CURR_PAGE', 1);
        this.$store.dispatch('getProducts');
      },

    },
    mounted(){
      this.getCategories();
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/LeftFilter.vue